import { __decorate, __metadata } from "tslib";
import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import ClientDetailsMixin from "../../ClientDetailsMixin";
import { ITeamOperationsSectionDTO, teamOperationsFieldKey, teamOperationsFieldLabel, teamOperationsSectionHasValues, } from "@/store/models/client/teamOperations";
/**
 * What the three Team Operations section modals share: typed values per field and the save request. Only changed
 * fields are sent. The modal stays open while saving, so a failed save keeps the edits.
 */
let TeamOperationsSectionEditMixin = /** @class */ (() => {
    var _a;
    let TeamOperationsSectionEditMixin = class TeamOperationsSectionEditMixin extends Mixins(ClientDetailsMixin) {
        constructor() {
            super(...arguments);
            // Typed values per field key; a key is present only once its input was touched
            this.drafts = {};
        }
        // "Add Process" until the section has values, then "Edit Process"
        get modalTitle() {
            return `${teamOperationsSectionHasValues(this.section) ? "Edit" : "Add"} ${this.section.name}`;
        }
        // Team dialogs use Save for a new record and Update once one exists
        get saveLabel() {
            return teamOperationsSectionHasValues(this.section) ? "Update" : "Save";
        }
        get changedFields() {
            const changed = [];
            this.section.groups.forEach((group) => group.rows.forEach((row) => row.fields.forEach((field) => {
                if (this.isFieldChanged(row, field)) {
                    changed.push({ key: teamOperationsFieldKey(row.itemId, field.attributeId), row, field });
                }
            })));
            return changed;
        }
        // Nothing is shown until a field changes
        get countText() {
            const count = this.changedFields.length;
            return count ? `${count} unsaved ${count === 1 ? "change" : "changes"}` : "";
        }
        inputValue(row, field) {
            const key = teamOperationsFieldKey(row.itemId, field.attributeId);
            return key in this.drafts ? this.drafts[key] : this.currentValue(field) || "";
        }
        isFieldChanged(row, field) {
            const key = teamOperationsFieldKey(row.itemId, field.attributeId);
            return key in this.drafts && this.normalize(this.drafts[key]) !== this.currentValue(field);
        }
        fieldLabel(row, field) {
            return teamOperationsFieldLabel(row, field);
        }
        setDraft(row, field, value) {
            this.$set(this.drafts, teamOperationsFieldKey(row.itemId, field.attributeId), value);
        }
        // Save is enabled only once a field changed
        save() {
            if (!this.changedFields.length) {
                return;
            }
            const dto = {
                teamId: this.teamId,
                changes: this.changedFields.map((item) => ({ itemId: item.row.itemId, attributeId: item.field.attributeId, value: this.normalize(this.drafts[item.key]) })),
            };
            this.$emit("save", dto);
        }
        close() { }
        currentValue(field) {
            return field.current ? field.current.value : null;
        }
        // Empty input saves as null (cleared)
        normalize(value) {
            const text = (value || "").trim();
            return text ? text : null;
        }
    };
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", String)
    ], TeamOperationsSectionEditMixin.prototype, "teamId", void 0);
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", typeof (_a = typeof ITeamOperationsSectionDTO !== "undefined" && ITeamOperationsSectionDTO) === "function" ? _a : Object)
    ], TeamOperationsSectionEditMixin.prototype, "section", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TeamOperationsSectionEditMixin.prototype, "saving", void 0);
    __decorate([
        Emit("close"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TeamOperationsSectionEditMixin.prototype, "close", null);
    TeamOperationsSectionEditMixin = __decorate([
        Component
    ], TeamOperationsSectionEditMixin);
    return TeamOperationsSectionEditMixin;
})();
export default TeamOperationsSectionEditMixin;
